import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/download/sec3_filter1-m.png'
import _imports_1 from '@/assets/img/download/sec3_filter1.png'
import _imports_2 from '@/assets/img/download/sec3_filter2.png'


const _withScopeId = n => (_pushScopeId("data-v-0553823d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "max-w-4xl mx-auto w-[896px]:px-0 px-10" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "block lg:hidden"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  class: "lg:block hidden"
}, null, -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "leading-relaxed" }, [
  /*#__PURE__*/_createTextVNode("전국 어디서나, "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 집에서 하는 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 파충류 거래")
], -1))
const _hoisted_8 = [
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["container transition-all duration-1000 w-full opacity-0", _ctx.elClass]),
      ref: "elRef"
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["group1 w-full transition-all duration-1000 px-0", _ctx.elClass])
      }, _hoisted_4, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["col1 delay-500 transition-all duration-1000 mx-auto", _ctx.elClass])
      }, _hoisted_6, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["col2 delay-700 transition-all duration-1000 sm:w-full bg-pada rounded-3xl flex justify-center items-center md:text-4xl text-white font-bold text-2xl w-full sm:py-0 py-20 mx-auto", _ctx.elClass])
      }, _hoisted_8, 2)
    ], 2)
  ]))
}